import { render } from "./LCAside.vue?vue&type=template&id=a59fcf4c&scoped=true"
import script from "./LCAside.vue?vue&type=script&lang=js"
export * from "./LCAside.vue?vue&type=script&lang=js"

import "./LCAside.vue?vue&type=style&index=0&id=a59fcf4c&scoped=true&lang=css"

import exportComponent from "D:\\work\\lift\\120.78.159.42\\lcJian\\LC特检通\\特检通\\120.78.159.42\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a59fcf4c"]])

export default __exports__